import axios from "axios";
import { Constants } from "../utils/Constants";

export function dashboard(form) {
    return axios.post(`${Constants.baseUrl}/inicio/dashboard`, form);
}

export function getIntegracaoWhatsapp() {
    return axios.get(`${Constants.baseUrl}/integracao-whatsapp`);
}